module.exports = __webpack_public_path__ + "static/project-3-4ec0061bc8808c7a2bc857e7eb1aba38.jpg";